import { clientAxios } from '@/plugins/axios'
import format from 'string-format'

const baseUrl = '/v1/setting/system/masterdata'
const checkRemoteIslandLink = `${baseUrl}/postal-code/{postal_code}/is-remote-island`
const getTargetDetailLink = `${baseUrl}/target/detail/`

export const getTargetDetail = async (names) =>
  clientAxios.get(getTargetDetailLink, {
    params: {
      name: names,
    },
  })
export const checkRemoteIsland = (postal_code) => clientAxios.get(format(checkRemoteIslandLink, { postal_code }))
